var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXIconCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.622,
    height: 35.622,
    viewBox: "0 0 35.622 35.622",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "X",
    transform: "translate(3.536 3.536)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4205",
    "data-name": "Trazado 4205",
    d: "M0,0V40.376",
    transform: "translate(28.55 0.001) rotate(45)",
    fill: "none",
    stroke: "#737373",
    strokeLinecap: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4206",
    "data-name": "Trazado 4206",
    d: "M0,0V40.376",
    transform: "translate(28.55 28.55) rotate(135)",
    fill: "none",
    stroke: "#737373",
    strokeLinecap: "round",
    strokeWidth: 5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIconCancel);
export default __webpack_public_path__ + "static/media/x_icon_cancel.77ab3937b0e74d0b367bb7505bca6c07.svg";
export { ForwardRef as ReactComponent };